import { axiosMockAdapterInstance } from "apis";

const user = {
  user: {
    id: "626775abe8b9a9006b74c8f8",
    firstName: "Bùi Ngọc",
    lastName: "Minh",
    email: "minhbn@sotanext.com",
    createdAt: "2022-04-26T04:31:39.237Z",
    updatedAt: "2022-04-26T04:31:39.237Z",
    role: "superadmin",
  },
};

export const onGetUserProfile = () => {
  axiosMockAdapterInstance.onGet("/users/me").reply(() => {
    return [200, user];
  });
};
